import { useChatsStore } from "@/store/useChatsStore";
import { computed, reactive, toRefs } from "@vue/composition-api";

interface RootState {
    entryIds: Map<number, number>;
}

const state: RootState = reactive({
    entryIds: new Map(),
});

export default function useReplies() {
    const chatsStore = useChatsStore();

    const addReply = (chatId: number, entryId: number) => {
        state.entryIds.set(chatId, entryId);
        state.entryIds = new Map(state.entryIds); // Workaround for Vue2 Map reactivity
    };

    const removeReply = (chatId: number) => {
        state.entryIds.delete(chatId);
        state.entryIds = new Map(state.entryIds); // Workaround for Vue2 Map reactivity
    };

    const activeReply = computed(() => {
        if (!chatsStore.activeChat) {
            return;
        }

        const currentEntryId = state.entryIds.get(chatsStore.activeChat.chat.id);
        if (!currentEntryId) {
            return;
        }

        return chatsStore.activeChat.entries.find((entry) => entry.id === currentEntryId);
    });

    return {
        addReply,
        removeReply,
        activeReply,
        ...toRefs(state),
    };
}
